<template>
    <list-page icone="mdi-account-group" titulo="Recurso Pessoal" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:botoes>
          <div>
            <info/>
          </div>          
        </template>
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.dataSaida`]="{ item }">
              {{item.dataSaida ? new Date(item.dataSaida).ddmmyyyy() : ''}}
            </template>

          </v-data-table>
          
          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-pessoal v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import { PessoalService } from '@/core/services/projetos';
import { Pessoal } from '@/core/domain/projetos';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false },
        { text: '#', value: 'id', type:'number' },
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Celular', value: 'celular' },
        { text: 'E-mail', value: 'email' },
        { text: 'Data Saída', value: 'dataSaida', type: 'date' },
      ],
      primeiraCarga: true
    }),
    created() {
      this.service = new PessoalService();
    },
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Pessoal());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new Pessoal(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>